//=========================================//
//    SHUFFLED INK | FILTERABLE GALLERY    //
//=========================================//

(function($) {
	$(document).ready(function() {

		// Template check
		if ( $('body').hasClass( 'page-template-page-gallery' ) ) {


			// Isotope
			var grid = $( '.gallery-isotope > section' ).isotope({
				itemSelector		: 'figure',
				percentPosition		: true,
				stagger				: 30,
				masonry: {
					columnWidth		: '.grid-sizer',
				}
			});

			// Fix overlaps
			grid.imagesLoaded().progress( function() {
				grid.isotope('layout');
			});


			// Mobile filter menu
			$( '#mobile-filter-toggle' ).on( 'click', function() {
				$( '#mobile-filter-menu').toggleClass( 'active' );
			});


			// Filter button click
			$( '.gallery-isotope > header' ).on( 'click', 'button', function() {

				// Set Filter
				var filterValue = $(this).attr( 'data-filter' );
				grid.isotope({ filter: filterValue });

				// Reset classes, then add the new active
				$( '#mobile-filter-menu' ).removeClass( 'active' );
				$( '.gallery-isotope > header button' ).removeClass( 'active' );
				$(this).addClass( 'active' );
			});

		} // gallery page
	}); // document.ready
})(jQuery);
